// src/pages/CourseDetail.js
import React from "react";
import { useParams } from "react-router-dom";
import { courseDetails } from "../components/CourseData";
import '../styles/EachCourseDetail.css';


const EachCourseDetail = () => {
  const { courseId } = useParams();
  const course = courseDetails[courseId];

  if (!course) return <h2>Course not found</h2>;

  return (
    <div className="course-detail-container">
      <h1>{course.title}</h1>
      <p><strong>Duration:</strong> {course.duration}</p>

      {course.modules.map((mod, index) => (
        <div key={index} className="course-module">
          <h3>{mod.name}</h3>
          <ul>
            {mod.topics.map((topic, i) => (
              <li key={i}>{topic}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default EachCourseDetail;
